module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.3073/images/canva-logo.png"